export const expectationColumns = [
  {
    title: '开始体重(kg)',
    dataIndex: 'initialBwforaa',
    width: 120,
    scopedSlots: { customRender: 'initialBwforaa' },
  },
  {
    title: '结束体重(kg)',
    dataIndex: 'finalBwforaa',
    width: 120,
    scopedSlots: { customRender: 'finalBwforaa' },
  },
  {
    title: '操作',
    dataIndex: 'x',
    width: 120,
    scopedSlots: { customRender: 'x' },
  },
]
export const chartsOne=[
  {
    titleText: "各阶段配方能量水平（kcal/kg）",
    dataset: {
      //数据模板
      // source: [
      //   ["product", "当前配方", "推荐配方"],
      //   ["20-50kg", 1.003, 0.081],
      //   ["50-75kg", 0.831, 0.734],
      //   ["75-100kg", 0.864, 1.652],
      //   ["100-140kg", 1.0074, 1.039],
      // ],
    },
  },
  {
    titleText: "各阶段饲料单价（元/头）",
    dataset: {},
  },
  {
    titleText: "各阶段肉料比",
    dataset: {},
  },
  {
    titleText: "各阶段饲料成本（元/头）",
    dataset: {},
  },
]

// 经济效益详情
export const inputEconomic = [
  { name: '经济效益计算方式', feild: 'ecoModel',codeKey:'EcoModel' },
  { name: '胴体市场价格', feild: 'gfCarcassPrice', unit: '元/kg' },
  { name: '活猪市场价格', feild: 'gfPigPrice', unit: '元/kg' },
  { name: '屠宰率', feild: 'slaughterrate', unit: '%' },
  { name: '饲料价格', feild: 'feedPriceModel'},
  { name: '配方优化价格', feild: 'nhf' },
  { name: '苗猪成本', feild: 'pigCost', unit: '元/头' },
  { name: '栏位成本模式', feild: 'pencostModel' },
  { name: '总栏位成本', feild: 'totalPencost', unit: '元/头' },
  { name: '日栏位成本', feild: 'pencost', unit: '元/头/天' },
  { name: '其他固定成本', feild: 'otherCost', unit: '元/头' },
  { name: '推荐最佳能量水平', feild: 'ecoOpt' },
]